// src/services/vendas/NotaPagService.js
import { deleteData, fetchData, postData, putData } from '../Api';
import { normalizeMoney } from '../../utils/numberUtils';

export const montarPayloadNotaPag = (pagamento) => {
  const { formaPag, _valorAutomatico, ...payload } = pagamento;
  return {
    ...payload,
    vPag: normalizeMoney(pagamento.vPag),
    vRec: normalizeMoney(pagamento.vRec),
    vTroco: normalizeMoney(pagamento.vTroco),
    qtdeParcela: pagamento.qtdeParcela || null,
    dataVencimento: pagamento.dataVencimento || null
  };
};

export const compararPayloadNotaPag = (pagamento) => JSON.stringify({
  id: pagamento.id,
  item: pagamento.item,
  notaId: pagamento.notaId,
  formaPagId: pagamento.formaPagId,
  vPag: normalizeMoney(pagamento.vPag),
  vRec: normalizeMoney(pagamento.vRec),
  vTroco: normalizeMoney(pagamento.vTroco),
  qtdeParcela: pagamento.qtdeParcela || null,
  dataVencimento: pagamento.dataVencimento?.substring(0, 10) || null,
  configTEFid: pagamento.configTEFid ?? null,
  tefNaoIntegrado: pagamento.tefNaoIntegrado === true,
  pago: pagamento.pago === true
});

export const buscarNotaPags = async (notaId) => {
  const resultado = await fetchData('/NotaPag/GetByNotaId', { notaId });
  if (!Array.isArray(resultado)) throw new Error('Resposta inválida ao consultar pagamentos.');
  return resultado;
};

export const salvarNotaPag = async (pagamento) => {
  const payload = montarPayloadNotaPag(pagamento);
  const resultado = pagamento.id
    ? await putData('/NotaPag', payload)
    : await postData('/NotaPag', payload);
  if (!resultado?.id) throw new Error('O servidor não retornou o pagamento salvo.');
  return resultado;
};

export const excluirNotaPag = async (id) => deleteData('/NotaPag', { id });
